import { FieldsService } from "../../../services/fields";
import { UpdateFieldRequestActionType } from "./../types";

export function* updateFieldSaga({ payload: { _id, data, type } }: UpdateFieldRequestActionType) {
    try {
        if (!_id.includes("tempId")) {
            //For future we need to make corrections for VALIDATIONS object
            yield FieldsService.updateField(_id, {
                type,
                //@ts-ignore
                data,
            });
        }
    } catch (error) {
        // yield put(Handle Error);
    }
}
